import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=0420dd0b&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=0420dd0b&prod&scoped=true&lang=css"
import style1 from "./ProductManagement.vue?vue&type=style&index=1&id=0420dd0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0420dd0b",
  null
  
)

export default component.exports